import React, { useState } from 'react';
import '../../App.css';
import '../joinWrapp/joinWrapp.css';
import FilledStar from '../../images/star.png';
import ShieldShape from '../../images/shield-check.svg';
import EmptyStar from '../../images/grey.png';
import Slider from 'react-slick';

  const testiSlider = {
    dots: false,          
    infinite: false,      
    speed: 2500,          
    slidesToShow: 1,     
    slidesToScroll: 1,   
    autoplay: true,      
    autoplaySpeed: 2000, 
    arrows: true,  
    variableWidth:false,      
  };

function JoinWrapp({ data, reviews }) {
  const [currentReview, setCurrentReview] = useState(0);

  if (!data) return <p>Loading...</p>;

  const totalReviews = reviews?.length || 0;

  const nextReview = () => {
    setCurrentReview((prev) => (prev + 1) % totalReviews);
  };

  const prevReview = () => {
    setCurrentReview((prev) => (prev - 1 + totalReviews) % totalReviews);
  };

  return (
    <section className="join-wrapp-new">
      <div className="container">
        <div dangerouslySetInnerHTML={{ __html: data?.eligibleheading }} />

        <div className="joinn-row row">
          {/* Left: Features */}
          <div className="col-md-6">
            <div className="why-join-features">
              <div className="features-grid">
                <div className="feature-card">
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z"></path>
                    </svg>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: data?.eligiblecontent }} />
                </div>
                <div className="feature-card">
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"></path>
                    </svg>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: data?.eligiblesubcontent }} />
                </div>
                <div className="feature-card">
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M20 6h-2.18c.11-.31.18-.65.18-1a3 3 0 00-3-3 3 3 0 00-3 3c0 .35.07.69.18 1H6a2 2 0 00-2 2v11a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2zm-8-1a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0z"></path>
                    </svg>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: data?.eligiblelink }} />
                </div>
                <div className="feature-card">
                  <div className="feature-icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 12l-2-2 2-2 5 5-5 5-2-2 2-2H2v-2h8.5z"></path>
                    </svg>
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: data?.joincontent4 }} />
                </div>
              </div>
            </div>
          </div>

          {/* Right: Testimonials */}
          <div className="col-md-6">
            <div className="why-join-testimonials">
              <div className="testimonial-slider">
                <Slider {...testiSlider}>  
                {totalReviews > 0 ? (
                  <div className="testimonial-slide">
                           <div className="rate-star">
                      {/* Display stars dynamically based on rating */}
                      {Array.from({ length: 5 }, (_, i) => (
                        <img
                          key={i}
                          src={i < reviews[currentReview].rating ? FilledStar : EmptyStar}
                          alt={i < reviews[currentReview].rating ? 'filled star' : 'empty star'}
                        />
                      ))}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: reviews[currentReview].reviewcontent,
                      }}
                    />
                  </div>
                ) : (
                  <p>No reviews yet.</p>
                )}
                </Slider>
                {/* Slider controls */}
                {totalReviews > 1 && (
                  <div className="slider-controls">
                    <button onClick={prevReview}>&lt;</button>
                    <button onClick={nextReview}>&gt;</button>
                  </div>
                )}
              </div>

              <div className="testimonial-stats">
                <div className="stat">
                  <span className="stat__num">{data?.australiancolumn1}</span>
                  <span className="stat__label">{data?.australiancolumn2}</span>
                </div>
                <div className="stat">
                  <span className="stat__num">{data?.australiancolumn3} ★</span>
                  <span className="stat__label">{data?.australiancolumn4}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default JoinWrapp;
